export const findMarketGroupByCategory = (byoMarketGroups, category) => byoMarketGroups.find((marketGroup) => marketGroup.category === category);
